import { makeStyles } from '@mui/styles'
import React from 'react'
import clsx from 'clsx'

import lang from '@/lang'
import ArrowLeft from '@assets/images/icons/arrow_left.svg'
import ArrowRight from '@assets/images/icons/arrow_right.svg'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import PDFIcon from '@assets/images/icons/pdf-extension.svg'
import { NumberInput } from '@/modules/base/components/inputs/index'
import customDecodeUri from '@/utils/customDecodeUri'
import ThemeInterface from '@/theme-interface'
import { useSignatureContext } from '../../_helpers/SignatureContext'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  container: {
    height: '100%',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  pager: {
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& div': {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 5,
    },
  },
  button: {
    background: 'transparent',
    border: 0,
    outline: 'none',
  },
  fileName: {
    fontFamily: 'Fira Sans',
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '1.44',
    letterSpacing: '0.36px',
    '& span.SVGInline': {
      marginRight: '10px',
    },
  },
  input: {
    height: 26,
    width: 26,
    fontSize: theme.fontSizes.small,
    textAlign: 'center',
    paddingLeft: 0,
  },
}))

const SignaturePager = (props) => {
  const classes = useStyles(props)
  const { pager, fileName, signingMode } = useSignatureContext()
  const { currentPage, nextPage, prevPage, numPages, setCurrentPage } = pager
  const { customClass } = props

  const handleSetPage = (value) => {
    if (value > 0 && value <= numPages) {
      setCurrentPage(+value)
    }
  }

  if (!numPages || numPages < 2) return null

  const containerClass = clsx(classes.container, customClass && customClass)
  return (
    <div className={containerClass}>
      <div className={classes.fileName}>
        {Boolean(fileName.length && signingMode > 0) && (
          <>
            <SVGIcon svg={PDFIcon} height="18px" width="18px" />
            {customDecodeUri(fileName)}
          </>
        )}
      </div>
      <div className={classes.pager}>
        <button
          className={classes.button}
          onClick={prevPage}>
          <SVGIcon fill="#000" height="12px" width="12px" svg={ArrowLeft} />
        </button>
        <div>
          {`${lang.agGrid.page} `}
          <NumberInput
            inputClassName={classes.input}
            showButtons={false}
            defaultValue={currentPage}
            onChange={handleSetPage}
            useFormik={false}
            dataQsId="signaturePager-pageInput" />
          {` ${lang.agGrid.of} ${numPages}`}
        </div>
        <button
          className={classes.button}
          onClick={nextPage}>
          <SVGIcon fill="#000" height="12px" width="12px" svg={ArrowRight} />
        </button>
      </div>
    </div>
  )
}

export default SignaturePager
